/**
 * Pill-toggle classes for the Accounts page's design-system Tabs (Shippers / Carriers, List / Onboarding, and the
 * onboarding info dialog). The library merges className with tailwind-merge, so these replace its pill styles rather
 * than stack.
 */
export const TABS_LIST_CLASS = 'h-10 gap-1 rounded-lg border border-[#cacaca] bg-[#fcfcfc] p-1';

/** Trigger classes to pair with TABS_LIST_CLASS. */
export const TABS_TRIGGER_CLASS = [
    'rounded-lg px-2 py-1.5 text-[13px] font-normal text-muted',
    'data-[state=active]:bg-primary data-[state=active]:font-medium data-[state=active]:text-primary-fg',
    'data-[state=active]:shadow-[0px_2px_2px_0px_rgba(0,0,0,0.3)]',
].join(' ');
